import { Box, Typography, useMediaQuery } from "@mui/material";
import InfoDetail from "../../Firms/Components/InfoDetail";
import VerifyWhatsapp from "../../../Common/VerifyWhatsapp";
import IconReusable from "../../../../components/IconReusable";
import { useState } from "react";
import { updateStaffAction } from "../API/Action/index";
import { toast } from "react-toastify";

export const WhatsAppSection = ({
  is_whatsapp_same,
  OwnerWhatsappNumber,
  ownerKey,
  labelDirection = "column",
  firmId,
  onWhatsappVerified,
  isEditable = true,
  verifyWhatsappProps = {},
  wrapperSx = {},
}) => {
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const [showVerifyWhatsapp, setShowVerifyWhatsapp] = useState(false);
  const [showCloseIcon, setShowCloseIcon] = useState(false);

  const handleWhatsappVerified = async (result) => {
    const payload = {
      firm_id: firmId,
      staff_details: {
        id: ownerKey,
        whatsapp_number: result.whatsappNumber,
        vfc_token: result.vfc_token,
        is_whatsapp_same: false,
        permissions: null,
      },
    };
    const { error, message } = await updateStaffAction(payload);
    if (!error) {
      toast.success(message);
      setShowVerifyWhatsapp(false);
      if (onWhatsappVerified) {
        await onWhatsappVerified();
      }
    } else {
      toast.error(message);
    }
  };

  const handleEdit = () => {
    setShowVerifyWhatsapp(true);
    setShowCloseIcon(true);
  };

  const handleWhatsAppClose = () => {
    setShowVerifyWhatsapp(false);
    setShowCloseIcon(false);
  };

  return (
    <>
      {is_whatsapp_same && !showVerifyWhatsapp && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}>
          <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
            <Box
              component={"img"}
              width={24}
              height={24}
              src={
                "https://d2djimvzddgguw.cloudfront.net/Humbee-auth-flow/whatsapp.svg"
              }
            />
            <Typography variant="body1" color="textSecondary">
              Given number is the same as WhatsApp number
            </Typography>
          </Box>
          {isEditable && (
            <Box onClick={() => handleEdit()} sx={{ cursor: "pointer" }}>
              <IconReusable
                name="Edit"
                size={isMobile ? 16 : 24}
                color="#333"
              />
            </Box>
          )}
        </Box>
      )}
      {!is_whatsapp_same && OwnerWhatsappNumber && !showVerifyWhatsapp && (
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
          }}>
          <InfoDetail
            label="WhatsApp"
            value={OwnerWhatsappNumber}
            direction={labelDirection}
            gap={0.5}
            labelVariant="labelD"
            valueVariant="body1"
            alignItems="flex-start"
          />

          {isEditable && (
            <Box
              onClick={() => handleEdit()}
              sx={{ cursor: "pointer", alignSelf: "center" }}>
              <IconReusable
                name="Edit"
                size={isMobile ? 16 : 24}
                color="#333"
              />
            </Box>
          )}
        </Box>
      )}
      {((!is_whatsapp_same && OwnerWhatsappNumber === null) ||
        showVerifyWhatsapp) && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            ...wrapperSx,
          }}>
          <VerifyWhatsapp
            ownerKey={ownerKey}
            initialValue={OwnerWhatsappNumber}
            onVerified={handleWhatsappVerified}
            onClose={handleWhatsAppClose}
            showCloseIcon={showCloseIcon}
            labelDirection={labelDirection}
            {...verifyWhatsappProps}
          />
        </Box>
      )}
    </>
  );
};
